document.addEventListener('DOMContentLoaded', function () {
  const tooltip = document.createElement('div');
  tooltip.className = 'tooltip';

  document.body.appendChild(tooltip);

  const tooltips = document.querySelectorAll('[data-tooltip]');
  tooltips.forEach((elem) => {
    elem.addEventListener('mouseenter', function () {
      tooltip.textContent = this.dataset.title;
      const root = document?.querySelector(':root');

      let elmPos = this?.getBoundingClientRect();
      let tipPos = tooltip?.getBoundingClientRect();
      let positionLeft = elmPos?.left + (elmPos?.width - tipPos?.width) / 2;
      let tooltipLeft = tipPos?.width / 2;

      if (positionLeft < 10) {
        positionLeft = 10;
        tooltipLeft = elmPos?.left + 5;
      }
      tooltip.style.left = positionLeft + 'px';
      tooltip.style.top = elmPos?.bottom + 10 + 'px';

      tooltip.style.visibility = 'visible';
      tooltip.style.opacity = '1';
      root.style.setProperty('--tooltip-left', `${tooltipLeft}px`);
    });

    elem.addEventListener('mouseleave', function () {
      tooltip.style.visibility = 'hidden';
      tooltip.style.opacity = '0';
    });
  });
});
